<div  class="a-form-with-input"  ngClass="{{focusClass}}" >
  <form [formGroup]="inputForm" class="a-form">
    <input type="text"
           class="a-form-input"
           placeholder="{{ placeholderKey | translate}}"
           (keydown)="handleKeyDownEvent($event)"
           (focus)="changeActive()"
           (blur)="changeActiveOff()"
           name="input"
           formControlName="{{ INPUT_NAME }}"
           autocomplete="off"
           #input
    >
  </form>
  <div class="a-form-input-reset"
       (click)="clearInputField()"
       *ngIf="showXBtn"
  >X</div>
  <ng-content></ng-content>

</div>

